import { BdsLoadingSpinner, BdsPaper } from 'blip-ds/dist/blip-ds-react/components';
import { ChipTag, Grid } from 'components';
import { MetricsContent } from 'components/MetricsContent';
import { MetricsTitle } from 'components/MetricsTitle';
import { useTranslation } from 'react-i18next';
import { MetricsLoadingProps } from 'typings/Loading';

type TicketsInQueueProps = {
    ticketsCount?: number;
    averageQueueTime?: string;
    maxQueueTime?: string;
    loading: MetricsLoadingProps;
};

export function TicketsInQueue({ ticketsCount, maxQueueTime, loading }: TicketsInQueueProps) {
    const { t } = useTranslation();
    return (
        <BdsPaper width="30%" className="metricsContainer" elevation="none">
            <Grid justifyContent="space-between" alignItems="center" margin="x-2">
                <MetricsTitle title={t('go-personal-tickets-queue-title')} />
                <ChipTag
                    value={t('go-personal-loading-percentage', { percentage: loading.ticketsPercentageLoaded ?? 0 })}
                    color={loading.ticketsPercentageLoaded === 100 ? 'outline' : 'default'}
                />
            </Grid>
            {loading.isTicketMetricsLoading ? (
                <Grid justifyContent="center">
                    <BdsLoadingSpinner />
                </Grid>
            ) : (
                <Grid direction="row" justifyContent="space-around" flexWrap="wrap" margin="x-4" alignItems="center" gap="3">
                    <MetricsContent
                        tooltipText={t('go-personal-tickets-queue-tooltip-count')}
                        tooltipPosition="right-top"
                        metricsValue={ticketsCount}
                    >
                        {t('go-personal-tickets-queue-count')}
                    </MetricsContent>
                    <MetricsContent
                        tooltipText={t('go-personal-tickets-queue-tooltip-max-time')}
                        tooltipPosition="right-top"
                        metricsValue={maxQueueTime}
                    >
                        {t('go-personal-tickets-queue-max-time')}
                    </MetricsContent>
                </Grid>
            )}
        </BdsPaper>
    );
}
